"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RestService = void 0;
var inversify_1 = require("inversify");
var TypeDefs_1 = require("./../../TypeDefs");
var rxjs_1 = require("rxjs");
var ajax_1 = require("rxjs/ajax");
var operators_1 = require("rxjs/operators");
var __1 = require("../..");
var RestService = exports.RestService = /** @class */ (function () {
    function RestService() {
    }
    RestService.prototype.prepareHeaders = function () {
        var headers = {};
        headers["Content-Type"] = "application/json";
        headers["Accept"] = "application/json";
        return headers;
    };
    RestService.prototype.getProtectedResource = function (request, additionalQueryStringParameters, authMandatory) {
        request.headers = request.headers || {};
        if (authMandatory === undefined || authMandatory === null) {
            authMandatory = true;
        }
        var map = this.prepareHeaders();
        for (var key in map) {
            if (map.hasOwnProperty(key)) {
                request.headers[key] = map[key];
            }
        }
        if (additionalQueryStringParameters) {
            var queryString = __1.ConfigHelper.mapToQueryString(additionalQueryStringParameters);
            var separator = request.url.indexOf("?") === -1 ? "?" : "&";
            request.url = "".concat(request.url).concat(separator).concat(queryString);
        }
        var requestObs;
        if (!this.applicationGuard || (!authMandatory && !this.applicationGuard.isAuthenticated())) {
            requestObs = (0, rxjs_1.of)(request);
        }
        else {
            requestObs = this
                .applicationGuard
                .modifyHttpRequest(request);
        }
        this.requestModifiers.forEach(function (requestModifier) {
            requestObs = requestObs.pipe((0, operators_1.flatMap)(requestModifier.modifyHttpRequest));
        });
        return requestObs
            .pipe((0, operators_1.flatMap)(function (ajaxRequest) {
            return (0, ajax_1.ajax)(ajaxRequest);
        }));
    };
    RestService.prototype.getUserId = function () {
        return this.applicationGuard
            .getUser()
            .restIdentityId;
    };
    __decorate([
        (0, inversify_1.inject)(TypeDefs_1.TypeDefs.ApplicationGuard),
        (0, inversify_1.optional)(),
        __metadata("design:type", Object)
    ], RestService.prototype, "applicationGuard", void 0);
    __decorate([
        (0, inversify_1.multiInject)(TypeDefs_1.TypeDefs.RequestModifier),
        (0, inversify_1.optional)(),
        __metadata("design:type", Array)
    ], RestService.prototype, "requestModifiers", void 0);
    RestService = __decorate([
        (0, inversify_1.injectable)()
    ], RestService);
    return RestService;
}());
//# sourceMappingURL=RestService.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/core/dist/services/impl/RestService.js
// module id = 1782
// module chunks = 0